import AttachmentApiService from '../services/AttachmentApiService'

const isExternalNonGcsUrl = (url: string): boolean => {
  if (!url) return false
  if (
    url.includes('storage.googleapis.com') ||
    url.includes('storage.cloud.google.com') ||
    url.startsWith('gs://')
  ) {
    return false
  }
  return url.startsWith('http://') || url.startsWith('https://')
}

export const getSignedAttachmentUrl = async (
  source: string,
  forceDownload = false,
  fileName?: string,
): Promise<string> => {
  if (!source) return ''
  if (!forceDownload && isExternalNonGcsUrl(source)) {
    return source
  }
  if (!forceDownload && source.includes('X-Goog-Signature')) {
    return source
  }
  try {
    const signedUrl = await AttachmentApiService.getSignedUrl(source, forceDownload, fileName)
    return signedUrl || source
  } catch {
    return source
  }
}

export const openSignedAttachment = async (
  source: string,
  target = '_blank',
  features = 'noopener,noreferrer',
): Promise<void> => {
  if (!source) return
  const url = await getSignedAttachmentUrl(source)
  if (url) {
    window.open(url, target, features)
  }
}

export default openSignedAttachment
